import { render, staticRenderFns } from "./DataAdicional.vue?vue&type=template&id=2251fcc6&scoped=true"
import script from "./DataAdicional.vue?vue&type=script&lang=js"
export * from "./DataAdicional.vue?vue&type=script&lang=js"
import style0 from "./DataAdicional.vue?vue&type=style&index=0&id=2251fcc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2251fcc6",
  null
  
)

export default component.exports